import {Form} from "react-bootstrap";
import React, {useEffect, useState, useRef} from "react";
import {EditInfoFooter} from "../../Components/Footers";
import { useNavigate, Link } from "react-router-dom";
import { Radio } from 'antd';
import usePortalService from "../../services/PortalService";
import exclamationCircle from '../../images/exclamation-circle.svg';
import emptyIconProfile from "../../images/emptyIconProfile.svg";
import UploadableAvatar from "../../Components/UploadableAvatar";
import type { RadioChangeEvent } from "antd";
import ErrorMessage from "../../Components/Errors/ErrorMessage";

type CommonInformationProps = {
  isBottom: boolean;
  handleFooter: () => void;
}

export const CommonInformation = ({isBottom, handleFooter}: CommonInformationProps) => {
  const { profileCommonInformation, updateProfileCommonInformation, sendConfirmLink, getAvatar, error, clearError } = usePortalService()

  const navigate = useNavigate()

  const avatarRef = useRef<any>(null);
  const [avatar, setAvatar] = useState('')

  const [lastName, setLastName] = useState('');
  const [lastNameDirty, setLastNameDirty] = useState(false);
  const [lastNameError, setLastNameError] = useState('');

  const [firstName, setFirstName] = useState('');
  const [firstNameDirty, setFirstNameDirty] = useState(false);
  const [firstNameError, setFirstNameError] = useState('');

  const [patronymic, setPatronymic] = useState('');

  const [gender, setGender] = useState('');

  const regEmail = /[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+/;
  const [email, setEmail] = useState("");
  const [emailDirty, setEmailDirty] = useState(false);
  const [emailError, setEmailError] = useState('');
  
  const [emailChanged, setEmailChanged] = useState(false);
  const [isConfirm, setIsConfirm] = useState(true);
  const [emailSended, setEmailSended] = useState(false);

  const regPhone = /^\d{11}$/;
  const [phone, setPhone] = useState("");
  const [phoneDirty, setPhoneDirty] = useState(false);
  const [phoneError, setPhoneError] = useState('');

  const [traineeshipSearch, setTraineeshipSearch] = useState(false)

  const [jobSearch, setJobSearch] = useState(false)

  const [region, setRegion] = useState('');
  const [regionDirty, setRegionDirty] = useState(false);
  const [regionError, setRegionError] = useState('');

  const [city, setCity] = useState('');
  const [cityDirty, setCityDirty] = useState(false);
  const [cityError, setCityError] = useState('');

  useEffect(() => {
    profileCommonInformation().then(result => {
      if (result.success) {
        setLastName(result.profile.lastName)
        setFirstName(result.profile.firstName)
        setPatronymic(result.profile.patronymic)
        setGender(result.profile.gender)
        setEmail(result.profile.email)
        setPhone(result.profile.phoneNumber)
        setTraineeshipSearch(result.profile.isTraineeship)
        setJobSearch(result.profile.isJob)
        setRegion(result.profile.region)
        setCity(result.profile.city)
        if (result.profile.avatarId) {
          getAvatar(result.profile.avatarId)  
          .then(result => {
              setAvatar(result)
          })
        } else {
            setAvatar(emptyIconProfile)
        }
      }
    })
    handleFooter()
  },[])

  const lastNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      setLastName(e.target.value)
      if (e.target.value.length < 1) {
          setLastNameError('Введите фамилию')
      } else if (e.target.value.length < 2) {
          setLastNameError('Фамилия не может состоять из одного символа')
      } else {
          setLastNameError('')
      }
  }

  const firstNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      setFirstName(e.target.value)
      if (e.target.value.length < 1) {
          setFirstNameError('Введите имя')
      } else if (e.target.value.length < 2) {
          setFirstNameError('Имя не может состоять из одного символа')
      } else {
          setFirstNameError('')
      }
  }

  const patronymicHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      setPatronymic(e.target.value)
  }

  const onGenderChange = (e: RadioChangeEvent) => {
      setGender(e.target.value);
  };

  const emailHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      setEmail(e.target.value)
      setEmailChanged(true)
      if (!regEmail.test(String(e.target.value).toLowerCase())) {
          setEmailError('Некорректный email')
      } else {
          setEmailError('')
      }
  }

  const phoneHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      setPhone(e.target.value)
      if (!regPhone.test(String(e.target.value).toLowerCase())) {
          setPhoneError('Некорректный номер телефона')
      } else {
          setPhoneError('')
      }
  }

  const regionHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      setRegion(e.target.value)
      if (e.target.value.length < 2) {
          setRegionError('Некорректное название региона')
      } else {
          setRegionError('')
      }
  }

  const cityHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      setCity(e.target.value)
      if (e.target.value.length < 2) {
          setCityError('Некорректное название города')
      } else {
          setCityError('')
      }
  }

  const sendHandler = () => {
      if (!emailSended) {
          sendConfirmLink();
          setEmailSended(true);
      }
  }

  const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
      switch (e.target.name) {
          case 'firstName':
              setFirstNameDirty(true)
              break;
          case 'lastName':
              setLastNameDirty(true)
              break;
          case 'email':
              setEmailDirty(true)
              break;
          case 'phone':
              setPhoneDirty(true)
              break;
          case 'region':
              setRegionDirty(true)
              break;
          case 'city':
              setCityDirty(true)
              break;
      }
  }

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (lastNameError || firstNameError || emailError || phoneError || regionError || cityError) {
      setLastNameDirty(true)
      setFirstNameDirty(true)
      setEmailDirty(true)
      setPhoneDirty(true)
      setRegionDirty(true)
      setCityDirty(true)
    } else {
        try {
            clearError();
            if (avatarRef.current) {
                await avatarRef.current.save();
            }
            const result = await updateProfileCommonInformation ({
                lastName,
                firstName,
                patronymic,
                gender,
                email,
                phoneNumber : phone,
                isTraineeship : traineeshipSearch,
                isJob : jobSearch,
                region,
                city
            });

            if (result.success) {
                if (result.isSendEmailConfirm) {
                    sessionStorage.setItem('email', email)
                    sessionStorage.setItem('headingAlert', 'Изменения успешно сохранены!')
                }
                navigate("/home");
            }
        } catch {
            // ошибка уже сохранена в error и отображается ниже
        }
    }
  }

  return(
    <>
      <div style={{maxWidth : "410px", width: "100%"}}>
        <h2 style={{marginBottom:'16px'}}>Общая информация</h2>
        <UploadableAvatar ref={avatarRef} src={avatar} style={{height : 114, objectFit : "cover", aspectRatio: "1/1", borderRadius : "0.5em"}} />
        <Form className="d-flex flex-column mt-3">
          <div className="form-group">
            <Form.Label> Фамилия </Form.Label>
            <Form.Control
              type="text"
              value={lastName}
              onBlur={blurHandler}
              onChange={lastNameHandler}
              isInvalid={!!(lastNameDirty && lastNameError)}
              name="lastName"
            />
            {(lastNameDirty && lastNameError) && <p className="error-alert">{lastNameError}</p>}
          </div>
          <div className="form-group">
            <Form.Label> Имя </Form.Label>
            <Form.Control
              type="text"
              value={firstName}
              onBlur={blurHandler}
              onChange={firstNameHandler}
              isInvalid={!!(firstNameDirty && firstNameError)}
              name="firstName"
            />
            {(firstNameDirty && firstNameError) && <p className="error-alert">{firstNameError}</p>}
          </div>
          <div className="form-group">
            <Form.Label> Отчество </Form.Label>
            <Form.Control
              type="text"
              value={patronymic}
              onBlur={blurHandler}
              onChange={patronymicHandler}
            />
          </div>
          <div className="d-flex gap-3" style={{marginBottom: "1.75em"}}>
            <Form.Label> Пол: </Form.Label>
            <Radio.Group onChange={onGenderChange} value={gender}>
                <Radio value={0}>Мужской</Radio>
                <Radio value={1}>Женский</Radio>
            </Radio.Group>
          </div>
          <div className="d-flex justify-content-between gap-4" style={{marginBottom:'16px'}}>
            <div>
              <Form.Label> Email </Form.Label>
              <Form.Control
                type="email"
                value={email}
                onBlur={(e: React.FocusEvent<HTMLInputElement>) => blurHandler(e)}
                isInvalid={!!(emailDirty && emailError)}
                name="email"
              />
              {(emailDirty && emailError) && <p className="error-alert">{emailError}</p>}
              {(!isConfirm && !emailChanged) && 
                  <>
                      <p style={{color: '#8C99A6', paddingTop:'4px'}}> 
                          <img src={exclamationCircle}/> Подтвердите адрес – перейдите по ссылке в письме. 
                          <p onClick={sendHandler}> Отправить повторное письмо </p> 
                      </p>
                  </>
              }
            </div>
            <div>
              <Form.Label> Телефон </Form.Label>
              <Form.Control
                type="text"
                value={phone}
                onBlur={blurHandler}
                onChange={phoneHandler}
                isInvalid={!!(phoneDirty && phoneError)}
                name="phone"
              />
              {(phoneDirty && phoneError) && <p className="error-alert">{phoneError}</p>}
            </div>
          </div>
          <div className="d-flex gap-3">
            <Form.Label> Я ищу: </Form.Label>
            <div>
              <Form.Check
                inline
                label="Стажировку"
                type="checkbox"
                checked={traineeshipSearch}
                onClick={() => setTraineeshipSearch(!traineeshipSearch)}
              />
              <Form.Check
                inline
                label="Работу"
                type="checkbox"
                checked={jobSearch}
                onClick={() => setJobSearch(!jobSearch)}
              />
            </div>
          </div>
          <h2 style={{marginBottom: "1.75em", marginTop: "1.75em"}}>Место жительства</h2>
          <div className="d-flex justify-content-between gap-4">
            <div>
              <Form.Label> Область </Form.Label>
              <Form.Control
                type="text"
                value={region}
                onBlur={blurHandler}
                onChange={regionHandler}
                isInvalid={!!(regionDirty && regionError)}
                name="region"
              />
              {(regionDirty && regionError) && <p className="error-alert">{regionError}</p>}
            </div>
            <div>
              <Form.Label> Город </Form.Label>
              <Form.Control
                type="text"
                value={city}
                onBlur={blurHandler}
                onChange={cityHandler}
                isInvalid={!!(cityDirty && cityError)}
                name="city"
              />
              {(cityDirty && cityError) && <p className="error-alert">{cityError}</p>}
            </div>
          </div>
        </Form>
      </div>
      {error && <ErrorMessage message={error} />}
      <EditInfoFooter isBottom={isBottom} onSave={handleSave} onCancel={() => navigate("/home")}/>
    </>
  )
}